// Components==============
import ArrowButton from 'components/UI/ArrowButton';
import Button from 'components/UI/Button';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useMediaQ } from 'utilities/useMediaQ';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import Agenda from 'components/UI/Agenda';
import Carousel from '../Carousel/Carousel';
import RichText from '../RichText';
import './index.module.scss';
// =========================

const Buttons = ({ buttons }) => {
    const { pathname } = useLocation();
    const routeSlug = pathname.split('/')[1];

    const tablet = useMediaQ('max', 1324);
    const openLoginModal = useOpenUrlModal('login-popup');

    if (!buttons?.length) return null;

    return (
        <div styleName="buttons">
            {/* {routeSlug === 'netwerk' && tablet && (
                <Button onClick={() => openLoginModal()}>Inloggen</Button>
            )} */}
            {buttons?.map((e) => (
                <ArrowButton
                    key={e?.text}
                    text={e?.text}
                    to={e?.link}
                    type={e?.type}
                    file={e?.file}
                    popup={e?.popup}
                />
            ))}
        </div>
    );
};

export default function HeroLayout({ children }) {
    const { pathname } = useLocation();
    let routeSlug = pathname.split('/')[1];
    if (routeSlug === 'school-aanbod') {
        routeSlug = pathname.split('/')[2];
    }

    const page = useSelector((state) => {
        const pages = state.page.entities.allIds.map(
            (pageId) => state.page.entities.byId[pageId]
        );
        return pages.find((p) => p.slug === routeSlug);
    });

    const query = useMediaQ('min', 1325);

    const image = page?.image;
    const useSlider = page?.use_slider;
    const images = page?.slider_images
        ?.map((item) => item?.attributes?.image)
        .map((item) => `/storage/${item}`);
    const title = page?.name;
    const richText = page?.content;
    const buttons = page?.buttons?.map((b) => b.attributes);

    return (
        <div styleName="wrapper">
            {!page ? (
                <>
                    <div styleName="hero">
                        <div
                            styleName={`${image ? 'image' : ''} header`}
                            style={{
                                background: image && `url(${image})`,
                            }}
                        >
                            <div styleName="overlay" />
                            <h1>Helaas, die pagina is niet gevonden</h1>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div styleName="hero">
                        {useSlider ? (
                            <Carousel images={images}>
                                <div
                                    styleName="image header"
                                    style={{ background: 'transparent' }}
                                >
                                    <h1>{title}</h1>
                                </div>
                            </Carousel>
                        ) : (
                            <div
                                styleName={`${image ? 'image' : ''} header`}
                                style={{
                                    background: image && `url(${image})`,
                                }}
                            >
                                <div styleName="overlay" />
                                <h1>{title}</h1>
                            </div>
                        )}
                        <div
                            styleName="bottom"
                            style={{
                                gridTemplateColumns: !buttons?.length && '1fr',
                            }}
                        >
                            {/* {!query && (
                                <>
                                    {routeSlug === 'netwerk' && (
                                        <Agenda network />
                                    )}
                                </>
                            )} */}
                            {richText.length > 0 ? (
                                <div styleName="text">
                                    <RichText richText={richText} />
                                </div>
                            ) : null}
                            {query && (
                                <div styleName="right">
                                    {/* {routeSlug === 'netwerk' && (
                                        <Agenda network />
                                    )} */}
                                    <Buttons buttons={buttons} />
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}

            {!query && <Buttons buttons={buttons} />}
            {children && <div>{children}</div>}
        </div>
    );
}
